import React, { createContext, useContext } from "react";

export const ProviderContext = createContext(null);

export const useProvider = () => useContext(ProviderContext);
